import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "children", "required", "stealthy", "wrapperRef", "onFocus", "onBlur", "onKeyDown", "aria-describedby", "disabled", "ref"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { useState } from 'react';
import styled from 'styled-components';
import AutosizeInput from 'react-input-autosize';
import Box from 'components/Box';
import { textInputStyle, textInputReset, textInputProps } from 'components/TextInput';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MockInput = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !textInputProps.includes(prop);
  }
}).withConfig({
  displayName: "TagInput__MockInput",
  componentId: "sc-vickv6-0"
})(["", " & input{", " max-width:100%;padding:0;}"], textInputStyle, textInputReset);
function TagInput(_ref) {
  var id = _ref.id,
    children = _ref.children,
    required = _ref.required,
    stealthy = _ref.stealthy,
    wrapperRef = _ref.wrapperRef,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    onKeyDown = _ref.onKeyDown,
    ariaDescribedBy = _ref['aria-describedby'],
    disabled = _ref.disabled,
    ref = _ref.ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFocused = _useState2[0],
    setIsFocused = _useState2[1];
  function handleFocus(e) {
    setIsFocused(true);
    onFocus === null || onFocus === void 0 || onFocus(e);
  }
  function handleBlur(e) {
    setIsFocused(false);
    onBlur === null || onBlur === void 0 || onBlur(e);
  }
  return /*#__PURE__*/_jsxs(MockInput, {
    ref: wrapperRef,
    isActive: isFocused,
    stealthy: stealthy,
    disabled: disabled,
    children: [/*#__PURE__*/_jsx(Box, {
      fillParent: true,
      as: "label",
      htmlFor: id,
      "aria-hidden": "true",
      style: {
        cursor: disabled ? 'not-allowed' : 'text'
      }
    }), /*#__PURE__*/_jsx(Box, {
      as: "span",
      position: "relative",
      children: children
    }), /*#__PURE__*/_jsx(AutosizeInput, _objectSpread(_objectSpread({}, otherProps), {}, {
      ref: ref,
      id: id,
      required: !!required,
      onFocus: handleFocus,
      onBlur: handleBlur,
      onKeyDown: onKeyDown,
      "aria-describedby": ariaDescribedBy,
      style: {
        maxWidth: '100%'
      },
      autoComplete: "off",
      spellCheck: "false",
      disabled: disabled
    }))]
  });
}
TagInput.displayName = 'TagInput';
export default TagInput;